import { BotMetadata } from '@feedyou/schema'
import { RootState } from '../../../reducers'
import { botMetadataSelector } from './botMetadataSelector'
import { openBotIdSelector } from '../../../store/app/selectors'

export function currentBotMetadataSelector(state: RootState): BotMetadata | undefined {
  const currentBotId = openBotIdSelector(state)

  return botMetadataSelector(currentBotId)(state)
}
